<template>
  <viewer
    class="image-viewer"
    :images="images"
    :options="options">
    <slot />
    <div
      v-if="enableUpload"
      class="upload-overlay">
      <a-upload
        :show-upload-list="false"
        :before-upload="handleUpload"
        accept="image/png, image/jpeg">
        <a-button
          type="primary"
          size="small">
          <edit-outlined />
        </a-button>
      </a-upload>
    </div>
  </viewer>
</template>

<script>
import { EditOutlined } from '@ant-design/icons-vue';

export default {
  components: {
    EditOutlined,
  },
  props: {
    images: {
      default: () => [],
      type: Array,
    },
    navbar: {
      default: false,
      type: Boolean,
    },
    enableUpload: {
      default: false,
      type: Boolean,
    },
    onUpload: {
      type: Function,
      default: () => {},
    },
  },
  setup(props) {
    const handleUpload = (file) => {
      props.onUpload(file);
      return false;
    };

    return {
      options: {
        loop: false,
        navbar: props.navbar,
        tooltip: false,
        scalable: false,
        transition: false,
      },
      handleUpload,
    };
  },
};
</script>

<style>
  .viewer-one-to-one,
  .viewer-play {
    display: none !important;
  }
  .viewer-toolbar ul li {
    margin: 0 5px !important;
  }
  .upload-overlay {
    position: absolute;
    bottom: 23px;
    right: 15px;
    z-index: 1000;
  }
</style>
